/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import TableLineIcons from "../../components/TableLineIcons";
import { Checkbox, Input } from "antd";


class CompanyBanks extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            searchText: ""
        };

        this.id_banks = "COMPANY_BANKS";

        this.api = {
            get_banks: "get_company_banks",
            create_edit_banks: "create_edit_company_banks",
            delete_banks: "delete_company_banks",

        }

        if (props.data[this.id_banks] === undefined) props.data[this.id_banks] = { ...props.data.genericData };

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(21574);
    }

    companyBankField = (text, record, field) => {
        const { editing, editedRecord } = this.props.data[this.id_banks];
        if (field == "bID") {
            return (<TableLineIcons
                onEdit={record.key == editing ? null : () => {
                    this.props.dataActions.genericDataStartEditing(this.id_banks, record.key, record.index)
                }}
                deleteQuetion={record.key == editing ? null : { title: this.getText(19065), okText: this.getText(19066), cancelText: this.getText(19067) }}
                onDelete={record.key == editing ? null : () => {
                    this.props.dataActions.genericDataDeleteRow(
                        this.id_banks, record.key, this.props.user.companyCode, this.props.user.token, this.api.delete_banks, this.api.get_banks);
                }}
                onCheck={record.key != editing ? null : () => {
                    this.props.dataActions.genericDataSaveEdit(
                        this.id_banks, this.props.user.companyCode, this.props.user.token, this.api.create_edit_banks, this.api.get_banks);
                }}
                onClose={record.key != editing ? null : () => {
                    if (editing == '0') this.props.dataActions.genericDataCancelInlineCreate(this.id_banks);
                    else this.props.dataActions.genericDataCancelEditing(this.id_banks);
                }}
            />)
        } else if (field == "bDefault") {
            return (<Checkbox
                checked={(record.key == editing) ? editedRecord[field] == 1 : text == 1}
                disabled={(record.key != editing)}
                onChange={e => { this.props.dataActions.genericDataSetEdit(this.id_banks, { [field]: e.target.checked ? '1' : '0' }) }}
            />)
        } else {
            return (record.key == editing) ?
                (<Input
                    value={editedRecord[field]}
                    onChange={e => { this.props.dataActions.genericDataSetEdit(this.id_banks, { [field]: e.target.value }) }}
                />)
                : text
        }
    }


    render() {
        let gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
        };

        return (<div style={divStyle}>
            <GenericTable
                {...this.props}
                id={this.id_banks}
                getApi={this.api.get_banks}
                title={gt(21574)}
                addButton={() => {
                    if (this.props.data[this.id_banks].editing === -1) {
                        this.props.dataActions.genericDataStartInlineCreate(this.id_banks);
                        setTimeout(() => {
                            this.props.dataActions.genericDataSetEdit(this.id_banks, { bDefault: '1' })
                        }, 500);
                    }
                }}
                columns={[
                    { title: this.getText(19057), key: "bBankNum", dataIndex: "bBankNum", width: "10%", render: (t, r) => this.companyBankField(t, r, "bBankNum") },
                    { title: this.getText(19058), key: "bBranchNum", dataIndex: "bBranchNum", width: "10%", render: (t, r) => this.companyBankField(t, r, "bBranchNum") },
                    { title: this.getText(19056), key: "bAccountNum", dataIndex: "bAccountNum", width: "10%", render: (t, r) => this.companyBankField(t, r, "bAccountNum") },
                    { title: this.getText(19059), key: "bDescription", dataIndex: "bDescription", width: "40%", render: (t, r) => this.companyBankField(t, r, "bDescription") },
                    { title: this.getText(19060), key: "bAccountingNumber", dataIndex: "bAccountingNumber", width: "10%", render: (t, r) => this.companyBankField(t, r, "bAccountingNumber") },
                    { title: this.getText(19063), key: "bDefault", dataIndex: "bDefault", width: "10%", render: (t, r) => this.companyBankField(t, r, "bDefault") },
                    { title: this.getText(19064), key: "bID", dataIndex: "bID", width: "10%", render: (t, r) => this.companyBankField(t, r, "bID") },
                ]}
            />
        </div>)
    }

}

export default CompanyBanks;